import type { ExcelColumn } from "@/types/excel";
import { formatINR } from "@/utils/app-formatters";
import { formatListDate } from "@/utils/date-format";

export type FmbReceiptAllocationLine = {
  fmbContributionId?: string | null;
  fmbTakhmeenId?: string | null;
};

export type FmbReceiptListRow = {
  receiptNo?: string | null;
  amount?: number | null;
  creditUsed?: number | null;
  unallocatedAmount?: number | null;
  receiptDate?: string | Date | null;
  receiptType?: string | null;
  paymentMode?: string | null;
  remarks?: string | null;
  allocations?: FmbReceiptAllocationLine[] | null;
  fmbData?: {
    itsNo?: string | null;
    name?: string | null;
    itsdata?: { Full_Name?: string | null } | null;
  } | null;
};

export function fmbReceiptTargetLabel(record: FmbReceiptListRow | null | undefined): string {
  const lines = record?.allocations;
  if (lines && lines.length > 1) {
    return `${lines.length} lines`;
  }
  if (lines?.length === 1) {
    return lines[0].fmbContributionId ? "Contribution" : "Annual";
  }
  return (record?.unallocatedAmount ?? 0) > 0 ? "Credit" : "—";
}

export function fmbReceiptHofIts(record: FmbReceiptListRow | null | undefined): string {
  return record?.fmbData?.itsNo?.trim() || "";
}

export function fmbReceiptHofName(record: FmbReceiptListRow | null | undefined): string {
  return record?.fmbData?.itsdata?.Full_Name?.trim() || record?.fmbData?.name?.trim() || "";
}

export const FMB_RECEIPT_EXPORT_COLUMNS: ExcelColumn<FmbReceiptListRow>[] = [
  { header: "Receipt No", field: "receiptNo", width: 15 },
  { header: "HOF ITS", field: (rec) => fmbReceiptHofIts(rec), width: 12 },
  { header: "Name", field: (rec) => fmbReceiptHofName(rec), width: 30 },
  {
    header: "Amount",
    field: "amount",
    width: 12,
    formatter: (_rec, v) => formatINR(v),
  },
  {
    header: "Credit used",
    field: "creditUsed",
    width: 12,
    formatter: (_rec, v) => formatINR(v ?? 0),
  },
  {
    header: "Unallocated",
    field: "unallocatedAmount",
    width: 12,
    formatter: (_rec, v) => formatINR(v ?? 0),
  },
  {
    header: "Receipt Date",
    field: "receiptDate",
    width: 15,
    formatter: (_rec, v) => (v ? formatListDate(String(v)) : ""),
  },
  { header: "Target", field: (rec) => fmbReceiptTargetLabel(rec), width: 16 },
  { header: "Receipt Type", field: "receiptType", width: 14 },
  { header: "Payment Mode", field: "paymentMode", width: 14 },
  { header: "Remarks", field: "remarks", width: 28 },
];

export const FMB_RECEIPT_EXPORT_OPTIONS = {
  filenamePrefix: "fmb-receipts",
  sheetName: "FMB Receipts",
} as const;
